<template>
  <ClientOnly>
    <Container
      is="nav"
      v-if="breadcrumbs"
      aria-label="Breadcrumbs Navigation"
      class="relative hidden h-14 min-w-max flex-row items-center sm:flex"
    >
      <div
        class="min-w-max bg-gray-800 pr-4 text-2xs font-medium leading-[3.5rem] text-white before:absolute before:h-full before:w-screen before:-translate-x-full before:bg-gray-800 md:pr-8"
      >
        Sie befinden sich hier:
      </div>
      <ul class="flex flex-row items-center pl-4 md:pl-8">
        <li class="hidden lg:flex">
          <NuxtLink
            to="/"
            class="hover-underline-animation-prose -mx-px inline-flex px-px align-middle text-2xs leading-tight !text-gray-800 after:h-[0.02em]"
          >
            Startseite
          </NuxtLink>
        </li>
        <li
          v-for="(crumb, index) in breadcrumbs"
          :key="index"
          class="last-of-type:font-semibold"
        >
          <NuxtLink
            v-if="
              crumb.url &&
              breadcrumbs.length !== index + 1 &&
              crumb.blueprint !== 'section'
            "
            :to="crumb.url"
            class="group"
          >
            <span class="px-1 text-2xs text-gray-800/40 no-underline lg:px-2"
              >/</span
            >
            <span
              class="hover-underline-animation-prose -mx-px inline-flex px-px align-middle text-2xs leading-tight !text-gray-800 after:h-[0.02em] group-focus-visible:rounded-[1em] group-focus-visible:ring-2 group-focus-visible:after:h-0"
            >
              {{ crumb.title }}
            </span>
          </NuxtLink>
          <span v-else>
            <span class="px-1 text-2xs text-gray-800/40 lg:px-2">/</span>

            <span class="text-2xs !text-gray-800">
              {{ crumb.title }}
            </span>
          </span>
        </li>
      </ul>
    </Container>
  </ClientOnly>
</template>

<script setup>
const props = defineProps({
  breadcrumbs: { type: [Boolean, Object], default: false },
})

const breadcrumbs = props.breadcrumbs ? props.breadcrumbs : useBreadcrumbs()
</script>
